import { message } from 'antd';

import axiosWithAuth from '@/lib/axios';

export const handleDeleteFixRecord = async (fixRecordId: string) => {
  try {
    await axiosWithAuth.delete(`/ezcon/api/fixRecords/${fixRecordId}`);
    message.success('刪除成功');
    return { success: true };
  } catch (error) {
    console.error(error);
    message.error('發生錯誤');
    return { success: false };
  }
};
